export const XS = 'xs';
export const SM = 'sm';
export const MD = 'md';
export const LG = 'lg';
export const XL = 'xl';
export const ALL_BREAKPOINTS = [XS, SM, MD, LG, XL];
export const DEFAULT_BP = XL;

export type BreakpointTypes = typeof XS | typeof SM | typeof MD | typeof LG | typeof XL;
